import React, { useState } from 'react';
import { Menu, Network } from 'lucide-react';
import { Sidebar, PageId } from './Sidebar';
interface DashboardLayoutProps {
  children: React.ReactNode;
  activePage: PageId;
  onPageChange: (page: PageId) => void;
  userName: string;
  onLogout: () => void;
}
export function DashboardLayout({
  children,
  activePage,
  onPageChange,
  userName,
  onLogout
}: DashboardLayoutProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <div className="min-h-screen bg-slate-50 flex flex-col lg:flex-row" data-id="element-58">
      <Sidebar activePage={activePage} onPageChange={onPageChange} userName={userName} onLogout={onLogout} isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} data-id="element-59" />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0" data-id="element-60">
        {/* Mobile Header */}
        <header className="lg:hidden bg-brand-navy text-white px-4 py-3 flex items-center justify-between sticky top-0 z-30 shadow-md" data-id="element-61">
          <div className="flex items-center gap-3" data-id="element-62">
            <button onClick={() => setIsMobileMenuOpen(true)} className="p-1 -ml-1 text-slate-300 hover:text-white min-h-[48px] min-w-[48px] flex items-center justify-center" data-id="element-63">
              <Menu className="w-6 h-6" data-id="element-64" />
            </button>
            <div className="flex items-center gap-2" data-id="element-65">
              <Network className="w-5 h-5 text-brand-teal" data-id="element-66" />
              <span className="font-bold tracking-tight" data-id="element-67">ERPLogiPark</span>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-x-hidden" data-id="element-68">
          {children}
        </main>
      </div>
    </div>;
}